import { sdkTypes } from '@vansite/ts-sharetribe-flex-sdk';
import Decimal from 'decimal.js';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import config from '../../config'; // Adjust the import path as needed
import { formatMoney } from '../currency';
// Adjust the import path as needed
const { Money } = sdkTypes;

/**
 * Custom hook that takes a price object and returns a formatted price and title.
 * If the currency is supported (matches the one in the config), it formats
 * the price with the appropriate currency symbol and includes a customer commission.
 * If the currency is not supported, it returns a string indicating the currency is unsupported.
 *
 * @param {object} price - The price object with `amount` and `currency` properties.
 * @param {number} withReduction - If set, the price will include
 * @returns {object} An object containing `formattedPrice` and `priceTitle`.
 */
export default function usePriceData(price, withReduction = 0) {
  const intl = useIntl();

  return useMemo(() => {
    if (price.currency === config.currency) {
      const commission = new Decimal(price.amount * (config.customerCommissionPercentage / 100)).round().toNumber();
      const finalAmount = new Money(new Decimal((price.amount + commission - withReduction)).round().toNumber(), price.currency);
      const formattedPrice = formatMoney(intl, finalAmount);
      return { formattedPrice, priceTitle: formattedPrice, priceWithCommission: finalAmount };
    } else {
      return {
        formattedPrice: `(${price.currency})`,
        priceTitle: `Unsupported currency (${price.currency})`,
        priceWithCommission: new Money(price.amount, price.currency),
      };
    }
  }, [intl, price, withReduction]);
}
